import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import "../css/AfloatRepairspage.css";

const AfloatRepairsPage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [galleryIndex, setGalleryIndex] = useState(0);

  const bannerSlides = [
    "/wp-content/uploads/2016/02/afloat 4.png",
    "/wp-content/uploads/2016/02/afloat 2.png",
    "/wp-content/uploads/2016/02/afloat 3.png",
    "/wp-content/uploads/2016/02/afloat 1.png",
  ];

  const galleryImages = [
    "/wp-content/uploads/2016/02/EM Astoria.jpg",
    "/wp-content/uploads/2016/02/Caravos AF.jpg",
    "/wp-content/uploads/2016/02/Vishva Bandhan.jpg",
    "/wp-content/uploads/2016/02/Ceylon Princess.jpg",
  ];

  useEffect(() => {
    const t = setInterval(
      () => setCurrentSlide((p) => (p + 1) % bannerSlides.length),
      3000,
    );
    return () => clearInterval(t);
  }, [bannerSlides.length]);

  useEffect(() => {
    const t = setInterval(
      () => setGalleryIndex((p) => (p + 1) % galleryImages.length),
      3000,
    );
    return () => clearInterval(t);
  }, [galleryImages.length]);

  return (
    <>
      <Header />

      {/* Banner */}
      <section id="main-banner" className="ar-banner">
        {bannerSlides.map((src, i) => (
          <img
            key={i}
            src={src}
            alt="Afloat Repairs"
            className={`ar-banner-img${i === currentSlide ? " active" : ""}`}
          />
        ))}

        <button
          className="ar-arrow ar-arrow--left"
          onClick={() =>
            setCurrentSlide(
              (p) => (p - 1 + bannerSlides.length) % bannerSlides.length,
            )
          }
          aria-label="Previous slide"
        >
          &#8249;
        </button>
        <button
          className="ar-arrow ar-arrow--right"
          onClick={() => setCurrentSlide((p) => (p + 1) % bannerSlides.length)}
          aria-label="Next slide"
        >
          &#8250;
        </button>

        <div className="ar-dots">
          {bannerSlides.map((_, i) => (
            <span
              key={i}
              className={`ar-dot${i === currentSlide ? " selected" : ""}`}
              onClick={() => setCurrentSlide(i)}
            />
          ))}
        </div>
      </section>

      {/* Body */}
      <section className="contentwrapper clearfix">
        <div className="content clearfix">
          <div className="breadcrumbs">
            <Link to="/">Home</Link> &gt; <span>Afloat Repairs</span>
          </div>

          <h1 data-aos="fade-right">Afloat Repairs</h1>

          {/* Top row: text + list + original brochure (will be hidden by CSS) */}
          <div className="ar-top-row">
            <div className="ar-col-text" data-aos="fade-right">
              <p>
                Colombo Dockyard launched Rapid Response Afloat Repair Services
                (RRARS) in May 2019 to meet growing demand for afloat and
                emergency ship repairs. Supported by a 3,000-strong workforce
                and full shipyard facilities, RRARS handles repairs in Indian
                waters, including docking surveys. Afloat repairs operates in
                Colombo, Hambantota, Trincomalee and Galle.
              </p>
            </div>

            <div className="ar-col-list" data-aos="fade-left">
              <p>Regular Repairs by RRARS</p>
              <ul>
                <li data-aos="fade-right" data-aos-delay="100">Afloat Steel renewals</li>
                <li data-aos="fade-right" data-aos-delay="150">Engine and Auxiliary machinery</li>
                <li data-aos="fade-right" data-aos-delay="200">Shaft line, Propeller and Stern Seals bonding/ renewal</li>
                <li data-aos="fade-right" data-aos-delay="250">Cargo Gears/ Load testing</li>
                <li data-aos="fade-right" data-aos-delay="300">Hydraulic systems</li>
                <li data-aos="fade-right" data-aos-delay="350">Electrical Motors, Alternators servicing and rewinding</li>
                <li data-aos="fade-right" data-aos-delay="400">Underwater inspections, Underwater Repairs and Renewals</li>
                <li data-aos="fade-right" data-aos-delay="450">Riding crew - All trades</li>
                <li data-aos="fade-right" data-aos-delay="500">Rope Access</li>
                <li data-aos="fade-right" data-aos-delay="550">Bollard pull tests upto 250 tons</li>
              </ul>
            </div>

            {/* Original brochure – kept but will be hidden via CSS */}
            <div className="ar-col-brochure">
              <a
                href="/wp-content/uploads/2023/08/Afloat Repair Brochure 2025.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="ar-brochure-link"
              >
                <img
                  src="/wp-content/uploads/2023/08/Afloat-Repair-Brochure-209x300.jpg"
                  alt="Afloat Repair Brochure"
                  width="209"
                  height="300"
                />
              </a>
            </div>
          </div>

          {/* Gallery row: spacer + brochure (new) + gallery + spacer */}
          <div className="ar-gallery-row">
            <div className="ar-gallery-spacer" />

            {/* Brochure added on the left side of gallery */}
            <div className="ar-col-brochure ar-col-brochure--gallery">
              <a
                href="/wp-content/uploads/2023/08/Afloat Repair Brochure 2025.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="ar-brochure-link"
              >
                <img
                  src="/wp-content/uploads/2023/08/Afloat-Repair-Brochure-209x300.jpg"
                  alt="Afloat Repair Brochure"
                  width="209"
                  height="300"
                />
              </a>
            </div>

            <div className="ar-gallery-col">
              <div className="ar-flexslider">
                {galleryImages.map((src, i) => (
                  <div
                    key={i}
                    className={`ar-flex-slide${i === galleryIndex ? " active" : ""}`}
                  >
                    <a
                      href={src}
                      data-fancybox="ar-gallery"
                      className="prettyphoto"
                    >
                      <img src={src} alt={`Afloat Repair ${i + 1}`} />
                    </a>
                  </div>
                ))}
              </div>
            </div>

            <div className="ar-gallery-spacer" />
          </div>
        </div>
      </section>

      <Footer />
      <BackToTop />
    </>
  );
};

export default AfloatRepairsPage;
